<template>
  <div class="contacts-table q-pa-lg bg-white-1 shadow3 border-radius-sm">
    <ContactModal
      v-model="contactModal"
      :main-address="mainAddress"
      :provider="data.provider"
      @created="contactCreated"
    />

    <AgGrid
      ref="agGrid"
      :options="options"
      :row-data="data.contacts"
      @row-selected="selectContactsRow"
      @ready="contactsTableReady"
    >
      <template #header>
        <Grid gaf="column" justify-content="space-between" align-items="center">
          <div class="text-body-4 text-secondary-1">Email will be sent to:</div>

          <PlusIcon @click.native="contactModal = true" />
        </Grid>
      </template>
    </AgGrid>
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
import { getDefaultAddress } from '@/reusable/address-fields/default-address'
import { options } from './options'
// Components
import PlusIcon from '@/ui/icons/PlusIcon'
import AgGrid from '@/ag-grid/AgGrid'
import ContactModal from '@/reusable/contact-modal/ContactModal'

export default {
  components: {
    PlusIcon,
    AgGrid,
    ContactModal
  },

  mixins: [options],

  props: {
    data: Object
  },

  data: () => ({
    selectedIds: [],
    contactModal: false,
    mainAddress: getDefaultAddress('main'),
    agGrid: null
  }),

  methods: {
    getSelectedIds() {
      return this.selectedIds
    },

    selectContactsRow({ row, isSelected }) {
      if (isSelected) this.selectedIds.push(row.id)
      else this.selectedIds = this.selectedIds.filter(subId => subId !== row.id)
    },

    contactsTableReady(agGrid) {
      this.selectedIds = []
      agGrid.api.selectAll()
      this.agGrid = agGrid
    },

    contactCreated(newContact) {
      this.agGrid.api.applyTransactionAsync({ add: [newContact] }, res => res.add[0].setSelected(true))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.contacts-table {
  @include table-with-no-filters;
}
</style>
